import { useState, useCallback, useMemo } from 'react'
import { useIntl } from 'umi'

import type { IntlShape } from 'react-intl'

type IChannelOptionsType = {
  id: IChannelType
  value: IChannelType
  label: string
  index: number
}

export enum IChannelType {
  WECHAT_MINI_PROGRAM = 1,
  WEB_PAGE = 2,
}

const getChannelsOptions: (intl: IntlShape) => IChannelOptionsType[] = (intl) => {
  return [
    {
      id: IChannelType.WECHAT_MINI_PROGRAM,
      value: IChannelType.WECHAT_MINI_PROGRAM,
      label: intl?.messages['Notification.store.type.title.wx'] as string,
      index: 0,
    },
    {
      id: IChannelType.WEB_PAGE,
      value: IChannelType.WEB_PAGE,
      label: intl?.messages['Notification.store.type.title.web'] as string,
      index: 1,
    },
  ]
}

const useChannelType = (channelType?: IChannelType, allowClear?: boolean) => {
  const intl = useIntl()

  const ChannelOptions = useMemo(() => getChannelsOptions(intl), [])

  const [selectedChannel, changeSelectedChannel] = useState(() => {
    return ChannelOptions.filter((channel) => channel.id === channelType)
  })

  const handleChannelTypeChange = useCallback(
    (e, { selection }: { selection: IChannelOptionsType[] }) => {
      if (!selection?.[0]?.value && !allowClear) return
      changeSelectedChannel(selection)
    },
    [changeSelectedChannel],
  )

  const changeChannelType = useCallback(
    (selection: IChannelOptionsType[]) => {
      if (!selection?.[0]?.value && !allowClear) return
      changeSelectedChannel(selection)
    },
    [changeSelectedChannel],
  )

  return {
    selectedChannel,
    ChannelOptions,
    handleChannelTypeChange,
    changeChannelType,
  }
}

useChannelType.ChannelType = IChannelType

export default useChannelType
